import { PayloadAction } from '@reduxjs/toolkit';

export type AppMode = 'standalone' | 'widget' | 'embedded';

export type AppModeAction = PayloadAction<AppMode, 'app/set-mode'>;

export const setAppMode = (mode: AppMode): AppModeAction => ({
	type: 'app/set-mode',
	payload: mode
});
